import PubSub from "underpub-js";

var CardTestimonial = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardTestimonial',
	};

	$.extend(true, this.options, options);

};

CardTestimonial.prototype.init = function() {

	var self = this;

};

export default CardTestimonial;
